export const WORKFLOW_STEP_KEYS = ['cloud', 'capture', 'develop', 'collaborate', 'release'] as const;

export type WorkflowStepKey = (typeof WORKFLOW_STEP_KEYS)[number];

/** Desktop carousel: welcome + one slide per workflow step + get started */
export const DESKTOP_ONBOARDING_SLIDE_COUNT = 1 + WORKFLOW_STEP_KEYS.length + 1;

export function getOnboardingLayoutType(): 'mobile' | 'desktop' {
  if (typeof window === 'undefined') return 'mobile';
  return window.innerWidth < 1024 ? 'mobile' : 'desktop';
}

const TECHNICAL_DEMO_NAME = /^(DEFAULT_|track-[a-f0-9]{8}$)/i;

/** Hide seeded/dev track ids like DEFAULT_TRACK_LOCAL from onboarding copy. */
export function resolveDemoTrackDisplayName(name: string | null | undefined, fallback: string): string {
  const trimmed = name?.trim();
  if (!trimmed || TECHNICAL_DEMO_NAME.test(trimmed)) return fallback;
  return trimmed;
}

export function resolveDemoTrackArtist(artist: string | null | undefined, fallback: string): string {
  const trimmed = artist?.trim();
  return trimmed || fallback;
}
